/**
 * @file: PlatformColor.web.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { ColorValue } from 'react-native';

export default function PlatformColor(...names: Array<string>): ColorValue {
  const [name] = names;
  switch (name) {
    case 'placeholderText':
      return '#C7C7CD';
    case 'separator':
      return '#eeeeee';
    case 'systemBackground':
      return '#FFFFFF';
    case 'systemGray':
      return '#8E8E93';
    case 'systemGray6':
      return '#F2F2F7';
    case 'label':
      return '#000000';
    case 'link':
      return '#007AFF';
    case 'systemRed':
      return '#FF3B30';
    default:
      return name;
  }
}
